// Declare a constant enum for colorPalette (Figma) colors
const enum colorPalette {
  // Main Brand Colors
  backgroundBlue = '#F9FBFF', // Define a light blue as another background color
  backgroundWhite = '#FFFF', // Define white as a background color
  paragraph = '#474742', // Define a color for paragraphs
  primaryBlue = '#2A5BDF', // Define a specific shade of blue for the primary color

  // Auxiliar Colors
  accentBlue1 = '#ECF1FD',
  accentBlue2 = '#215585',
  accentGreen1 = '#3DDB69',
  accentGreen2 = '#076105',
  accentPurple = '#9240B9',
  accentRed = '#EF565F',
  accentYellow = '#EDCF66',
  darkGray1 = '#474747',
  destructiveRed1 = '#DE1A1A',
  destructiveRed2 = '#AD1414',
  destructiveRed3 = '#730D0D',
  focusPurple = '#B770FE',
  imageDummyContainer = '#E5E5E5',
  imageDummyIcon = '#717273',
  primaryHoverBlue1 = '#C0D1FF',
  primaryHoverBlue2 = '#2046AD',
  primaryPressedBlue = '#152E73',
  secondaryBlue = '#7F9CEC',
  secondaryBaseGrayBlue = '#9C9FAB',
  tableBlueCell = '#E7ECF3',
  videoContainer = '#E9E9EF',

  // Black Tints and Shades
  black = '#111111',
  disabledGray1 = '#ECECED',
  disabledGray2 = '#B5B5B6',
  neutralGray1 = '#F5F5F6',
  neutralGray2 = '#D8D8D9',
  neutralGray3 = '#323232',
  paragraphBaseline = '#474748',
  paragraphPlaceholder = '#979899',

  // MuiRadio Colors
  radioHover = 'rgba(181, 181, 182, 0.12)',
  radioFocus = 'rgba(181, 181, 182, 0.25)',
}

// Export the colorPalette enum for use in other files
export { colorPalette };

const enum docGeniusPalette {
  cardDndAccentblue = '#467077',
  neutralGray = '#474748',
  primaryBlue = '#265183',
  secondaryBlue = '#3495B4',
  trackingCardBackgroundColor = '#F5F5F5',
  trackingCardNotSelected = '#e6eef1',
  tableHeader = '#3067a6',
}

// Export the docGeniusPalette enum for use in other files
export { docGeniusPalette };
